
import { apiClient } from '@/lib/mockApi';


export const academyService = apiClient;

export const getCursosPublicos = async () => ({ data: [], error: null });
export const getMatriculasDoUsuario = async () => ({ data: [], error: null });
export const matricularEmCurso = async () => ({ data: [], error: null });
export const getCursoById = async () => ({ data: [], error: null });
export const getModulosDoCurso = async () => ({ data: [], error: null });
export const getAulasDoCurso = async () => ({ data: [], error: null });
export const getAulaById = async () => ({ data: [], error: null });
export const marcarAulaComoConcluida = async () => ({ data: [], error: null });